import { useContext } from 'react';
import LANG from '../lang/lang.js';
import LangContext from '../lang/langContext.js';

function useLang() {
  var lang = useContext(LangContext);
  return lang || LANG.EN_CA;
}

export { useLang as default };
